var v = /* @__PURE__ */ ((u) => (u.auto = "auto", u.start = "start", u.center = "center", u.end = "end", u.restore = "0", u))(v || {}), x = /* @__PURE__ */ ((u) => (u.start = "start", u.end = "end", u))(x || {});
export {
  x as FirstMessagePositioning,
  v as PrependScrollRestorationStrategy
};
